<template>
  <v-container>
    <v-row align="center" class="row--35">
      <v-col lg="5" md="5" cols="12" class="text-center text-md-left">
        <div class="thumbnail">
          <slot name="thum-img"></slot>
        </div>
        <div class="founders-caption">
          <p class="founders-names">Leonardo e Maria Eduarda</p>
          <p class="founders-location">Fundadores • Itajaí, SC</p>
        </div>
      </v-col>
      <v-col lg="7" md="7" cols="12">
        <div class="about-inner inner">
          <div class="section-title">
            <div class="about-title-row">
              <div class="icon" v-html="iconSvg(icon)"></div>
              <span class="kicker">Sobre a empresa</span>
            </div>
            <h2 class="heading-title">Expertise validada pelo mercado.</h2>
            <p class="description">
              Com 8 anos de atuação e dezenas de sistemas críticos em produção, a Codetime se consolidou como referência em desenvolvimento sob medida em Itajaí.
            </p>
            <p class="description">
              Oferecemos o equilíbrio exato que o seu negócio precisa: a segurança técnica de uma estrutura corporativa, somada à agilidade de um parceiro local. Entregamos a tranquilidade de uma operação rodando sobre uma base tecnológica robusta.
            </p>
            <div class="purchase-btn">
              <a
                class="btn-transparent btn-whatsapp"
                href="https://wa.me/5547933807051"
                target="_blank"
                rel="noopener"
              >
                <!-- <span class="whatsapp-icon" v-html="whatsappIcon"></span> -->
                AGENDAR REUNIÃO
              </a>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import feather from "feather-icons";
  export default {
    data() {
      return {
        icon: "send",
        whatsappIcon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.372a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>`,
      };
    },
    methods: {
      iconSvg(icon) {
        return feather.icons[icon].toSvg();
      },
    },
  };
</script>

<style lang="scss" scoped>
.thumbnail {
  position: relative;
  display: block;
  max-width: 380px;
  margin: 0 auto 12px auto;
  padding: 2px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(0,140,247,0.9), rgba(118,68,255,0.55), rgba(249,93,129,0.85));
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.35);
}
.thumbnail::after {
  content: "";
  position: absolute;
  inset: 2px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(255,255,255,0.10), rgba(255,255,255,0.02) 60%, rgba(255,255,255,0.12));
  backdrop-filter: blur(1.2px) saturate(1.05);
  -webkit-backdrop-filter: blur(1.2px) saturate(1.05);
  pointer-events: none;
}
.thumbnail img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 14px;
  position: relative;
  z-index: 1;
}
@media (max-width: 960px) {
  .thumbnail { 
    max-width: 320px; 
    margin: 0 auto 20px auto;
    text-align: center;
  }
  .row--35 {
    justify-content: center;
  }
}
@media (max-width: 600px) {
  .thumbnail { 
    max-width: 280px; 
    margin: 0 auto 25px auto;
    text-align: center;
  }
  .row--35 {
    justify-content: center;
    text-align: center;
  }
  .about-inner {
    text-align: center;
  }
  .about-title-row {
    justify-content: center;
  }
}
.about-title-row { display: flex; align-items: center; gap: 10px; margin-bottom: 8px; }
.about-title-row .icon { flex: 0 0 auto; }
.kicker { font-weight: 700; color: #c6c9d8; letter-spacing: .2px; font-size: clamp(18px, 2vw, 24px); display: inline-flex; align-items: center; line-height: 1; }
.about-inner .section-title .heading-title {
  font-size: clamp(24px, 2.6vw, 40px);
  line-height: 1.3;
  margin-top: 6px;
}
.about-inner .section-title p.description {
  font-size: clamp(13px, 1.1vw, 15px);
  line-height: 1.6;
}
.founders-caption {
  margin-top: 16px;
  text-align: center;
}
.founders-names {
  font-weight: 600;
  font-size: clamp(16px, 1.3vw, 18px);
  color: #8698b2;
  margin-bottom: 4px;
  line-height: 1.4;
}
.founders-location {
  font-size: clamp(12px, 1vw, 14px);
  color: #64748b;
  margin: 0;
  line-height: 1.4;
}
.btn-whatsapp {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}
.btn-whatsapp:hover {
  transform: translateY(-2px);
}
.whatsapp-icon {
  display: inline-flex;
  align-items: center;
  width: 18px;
  height: 18px;
}
.whatsapp-icon svg {
  width: 100%;
  height: 100%;
  fill: currentColor;
}
@media (max-width: 600px) {
  .founders-caption {
    margin-top: 20px;
  }
}
</style>
